import React, { useState, useEffect, useCallback } from "react";
import { Box, Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { fancyTimeFormat, getFormatedDate } from "../../../Js/TimeAndDate";
import { randomNumber } from "../../../Js/Common";
import ReadMore from "../../../Js/ReadMore";
import { makeStyles } from "@material-ui/core/styles";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const NestedAccordion = (props) => {
    const styles = useStyles();

    //State    
    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    // console.log("tableDetailData====>", props.tableDetailData);

    return (
        <>
            {props.tableDetailData.children && props.tableDetailData.children.length > 0 && (
                <>
                    {props.tableDetailData.children.map((sectionData, index) => {
                        return (
                            <>
                                <Accordion
                                    expanded={expanded === "panel" + sectionData.id}
                                    onChange={handleChange("panel" + sectionData.id)}
                                    sx={{ backgroundColor: "#F5F7FF", boxShadow: 0, my: 1, mx: sectionData.level == 'root' ? 0 : 2 }}
                                    key={`accordion_${sectionData.id}`}
                                >
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon sx={{ color: "primary.main" }} />}
                                        aria-controls={`panel${sectionData.id}bh-content`}
                                        id={`panel${sectionData.id}bh-header`}
                                    >
                                        {sectionData.level == 'root' &&
                                            <Typography
                                                sx={{
                                                    width: "75%",
                                                    color: "#DB8829",
                                                    fontSize: "0.9rem",
                                                    fontWeight: "600",
                                                }}
                                            >
                                                Class: {props.filterClass(sectionData.classId)}
                                            </Typography>}
                                        {sectionData.level == 'parent' &&
                                            <>
                                                <Typography
                                                    sx={{
                                                        width: "75%",
                                                        color: "#DB8829",
                                                        fontSize: "0.9rem",
                                                        fontWeight: "600",
                                                    }}
                                                >
                                                    Date: {getFormatedDate(sectionData.dateId, "DD MMM YYYY")}
                                                </Typography>
                                                <Typography
                                                    sx={{
                                                        fontSize: "0.9rem",
                                                        color: "#A9A9A9",
                                                        "@media (min-width: 1636px)": { fontSize: "1rem" },
                                                    }}
                                                >
                                                    Total Time: {fancyTimeFormat(sectionData.totalTime) + " m"}
                                                </Typography></>}
                                    </AccordionSummary>

                                    {sectionData.level == 'parent' && (
                                        <AccordionDetails>
                                            <TableContainer
                                                sx={{
                                                    height: "35vh",
                                                    overflow: "auto",
                                                    pr: 2,
                                                }}
                                                className={styles.scrollBar}
                                            >
                                                <Table>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell
                                                                sx={{
                                                                    color: "#DB8829",
                                                                    fontSize: "1rem",
                                                                    fontWeight: "600",
                                                                    padding: "5px",
                                                                    "@media (min-width: 1636px)": {
                                                                        fontSize: "1.4rem",
                                                                    },
                                                                }}
                                                            >
                                                                Item
                                                            </TableCell>
                                                            <>
                                                                <TableCell
                                                                    sx={{
                                                                        color: "#DB8829",
                                                                        fontSize: "1rem",
                                                                        fontWeight: "600",
                                                                        padding: "5px",
                                                                        "@media (min-width: 1636px)": {
                                                                            fontSize: "1.4rem",
                                                                        },
                                                                    }}
                                                                >
                                                                    Class Name
                                                                </TableCell>
                                                                <TableCell
                                                                    sx={{
                                                                        color: "#DB8829",
                                                                        fontSize: "1rem",
                                                                        fontWeight: "600",
                                                                        padding: "5px",
                                                                        "@media (min-width: 1636px)": {
                                                                            fontSize: "1.4rem",
                                                                        },
                                                                    }}
                                                                >
                                                                    Topic
                                                                </TableCell>
                                                            </>
                                                            <TableCell
                                                                align="center"
                                                                sx={{
                                                                    color: "#DB8829",
                                                                    fontSize: "1rem",
                                                                    fontWeight: "600",
                                                                    padding: "1px",
                                                                    "@media (min-width: 1636px)": {
                                                                        fontSize: "1.4rem",
                                                                    },
                                                                }}
                                                            >
                                                                Duration
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {sectionData.detailData.length > 0 &&
                                                            sectionData.detailData.map((detailData, index) => {
                                                                return (
                                                                    <TableRow key={index}>
                                                                        <TableCell
                                                                            sx={{
                                                                                color: "#DB8829",
                                                                                fontSize: "0.9rem",
                                                                                fontWeight: "500",
                                                                                padding: "10px",
                                                                                "@media (min-width: 1636px)": {
                                                                                    fontSize: "1.2rem",
                                                                                },
                                                                            }}
                                                                        >
                                                                            {detailData.title}
                                                                        </TableCell>

                                                                        <TableCell
                                                                            sx={{
                                                                                color: "#DB8829",
                                                                                fontSize: "0.9rem",
                                                                                fontWeight: "500",
                                                                                padding: "10px",
                                                                                "@media (min-width: 1636px)": {
                                                                                    fontSize: "1.2rem",
                                                                                },
                                                                            }}
                                                                        >
                                                                            {detailData?.context?.className || "-"}
                                                                        </TableCell>
                                                                        <TableCell
                                                                            sx={{
                                                                                color: "#DB8829",
                                                                                fontSize: "0.9rem",
                                                                                fontWeight: "500",
                                                                                padding: "10px",
                                                                                "@media (min-width: 1636px)": {
                                                                                    fontSize: "1.2rem",
                                                                                },
                                                                            }}
                                                                        >
                                                                            <ReadMore
                                                                                text={detailData?.context?.topicPath || "-"}
                                                                                maxChars={'30'}
                                                                            />
                                                                        </TableCell>

                                                                        <TableCell
                                                                            align="center"
                                                                            sx={{
                                                                                color: "#DB8829",
                                                                                fontSize: "0.9rem",
                                                                                fontWeight: "500",
                                                                                padding: "10px",
                                                                                "@media (min-width: 1636px)": {
                                                                                    fontSize: "1.2rem",
                                                                                },
                                                                            }}
                                                                        >
                                                                            {fancyTimeFormat(detailData.sum) + " m"}
                                                                        </TableCell>
                                                                    </TableRow>
                                                                );
                                                            })}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </AccordionDetails>
                                    )}
                                    {sectionData.level != 'parent' &&
                                        sectionData.children &&
                                        sectionData.children.length > 0 && (
                                            <NestedAccordion
                                                tableDetailData={sectionData}
                                                filterClass={props.filterClass}
                                            />
                                        )
                                    }
                                </Accordion>

                            </>
                        );
                    })}
                </>
            )}
        </>
    );
};
const useStyles = makeStyles({
    scrollBar: {
        "&::-webkit-scrollbar": {
            width: "0.5em",
        },
        "&::-webkit-scrollbar-track": {
            backgroundColor: "#ffe600ff",
            "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
            borderRadius: 5,
        },
        "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#5f5600ff",
            borderRadius: 5,
        },
    },
});
export default NestedAccordion;
